require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-luigi-snozzi.json") })
        }
      }, "path---interviste-luigi-snozzi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-luigi-snozzi!./.cache/json/interviste-luigi-snozzi.json
// module id = 679
// module chunks = 231608221292675